@import (reference) '../../../../../constants/spacing.module.less';

.button-group {
  margin-left: auto;
}

.layout {
  margin: 0 auto;
  max-width: 1200px;
}
